import { storeAnswer } from '../../services/manager';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import SessionScreen from './SessionScreen';
import VideoPlayer from '../../components/VideoPlayer'
import { useEffect } from 'react';

export type StoredValue = string;

export default function Screen(props: WrapperScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  async function answer(doIntro: String) {
    await storeAnswer('83', t('screens:83.uuid'), doIntro as StoredValue);
    navigate('/session/35', { replace: true });
  }

  // async function goBack() {
  //   navigate(-1);
  // }

  useEffect(() => {
    props.useAudio('');
  });

  const actions = (<>
    <Button label={t('continue')} variant="primary" onClick={() => answer('true')} />
  </>);

  return (
    <SessionScreen
      screen="83"
      title={`${t('screens:83.step')} ${t('screens:83.title')}`}
      chapter={2}
      progress={45}
      actions={actions}
    >
      <VideoPlayer src={t('screens:83.source')} poster={t('screens:83.poster')} />
    </SessionScreen>
  );
};
